import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Data, Router } from '@angular/router'
import { map, take } from 'rxjs/operators'
import { appConfig } from '../../../../brands/_current/config/app-config'
import { PendingPageData } from '../../../pending-operation/shared/pending-data.model'

@Component({
  selector: 'app-unconfirmed-account-page',
  templateUrl: './unconfirmed-account-page.component.html',
  styleUrls: ['./unconfirmed-account-page.component.scss'],
})
export class UnconfirmedAccountPageComponent implements OnInit {
  public brandName = appConfig.core.brandName
  public helplineNumber: string
  public pendingData: PendingPageData
  public confirmMobilePath: string[]

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.helplineNumber = appConfig.core.helplineNumber
    this.confirmMobilePath = [
      '/',
      appConfig.pendingOperation.paths._root,
      appConfig.pendingOperation.paths.confirmMobile,
    ]
    this.route.data
      .pipe(
        take(1),
        map<Data, PendingPageData>((data) => data.pendingData),
      )
      .subscribe((data) => (this.pendingData = data))
  }
}
